export const getClinicPublicCacheKey = (slug?: string) => {
  if (!slug) return null;
  return `clinic-public-cache:${slug.toLowerCase()}`;
};

export const readClinicPublicCache = <T>(slug?: string): T | null => {
  if (typeof window === "undefined") return null;

  const key = getClinicPublicCacheKey(slug);
  if (!key) return null;

  try {
    const raw = window.sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
};

export const writeClinicPublicCache = <T>(slug?: string, payload?: T | null) => {
  if (typeof window === "undefined") return;

  const key = getClinicPublicCacheKey(slug);
  if (!key || !payload) return;

  try {
    window.sessionStorage.setItem(key, JSON.stringify(payload));
  } catch {
    // Ignore storage failures silently
  }
};
